import { uid } from 'uid';
import Vue from 'vue'

Vue.prototype.$uid = ()=>{
    return uid(24)
}